// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner-module__spinner___3hpPy","rotate":"Spinner-module__rotate___3QHO8","path":"Spinner-module__path___21pzA","dash":"Spinner-module__dash___2olzh"};